<template>
  <section id="datasertifikat">
    <div class="card container-1056 py-16 px-16">
      <h1 class="title is-4 has-text-centered">{{ actionTitle }} Sertifikat</h1>
      <div class="rows">
        <div class="row">
          <div class="columns">
            <div class="column">
              <b-field
                label="Periode Pelaksanaan"
                :type="form.periode_pelaksanaan.type"
                :message="form.periode_pelaksanaan.message">
                <b-input
                  name="periode_pelaksanaan"
                  @input="clearError(form.periode_pelaksanaan)"
                  placeholder="Periode Pelaksanaan"
                  v-model="form.periode_pelaksanaan.value"
                  expanded
                  :disabled="state">
                </b-input>
              </b-field>
              <b-field
                label="Tempat Terbit Sertifikat"
                :type="form.tempat_terbit.type"
                :message="form.tempat_terbit.message">
                <b-input
                  name="tempat_terbit"
                  @input="clearError(form.tempat_terbit)"
                  placeholder="Tempat Terbit"
                  v-model="form.tempat_terbit.value"
                  expanded
                  :disabled="state">
                </b-input>
              </b-field>
              <b-field
              label="Nama Koordinator Biro"
              :type="form.nama_koordinator.type"
              :message="form.nama_koordinator.message">
              <b-input name="nama_koordinator" @input="clearError(form.nama_koordinator)"  
                placeholder="Nama Koordinator Biro" v-model="form.nama_koordinator.value" expanded :disabled="state"></b-input>
              </b-field>
            </div>
            <div class="column">
              <b-field
                label="Tanggal Terbit Sertifikat"
                :type="form.tanggal_terbit.type"
                :message ="form.tanggal_terbit.message">
                <b-datepicker
                  ref="datepicker"
                  locale="en-GB"
                  v-model="form.tanggal_terbit.value"
                  @input="clearError(form.tanggal_terbit)"
                  placeholder="Pilih Tanggal Terbit"
                  expanded
                  :disabled="state">
                </b-datepicker>
              </b-field>
              <b-field
                label="Durasi (Jam)"
                :type="form.duration.type"
                :message="form.duration.message">
                <b-input
                  name="duration"
                  @input="clearError(form.duration)"
                  placeholder="Duration Jam"
                  v-model="form.duration.value"
                  expanded
                  :disabled="state">
                </b-input>
              </b-field>
              <b-field
                label="Jenis Paket"
                :type="form.jenis_paket.type"
                :message="form.jenis_paket.message">
                <b-select
                  v-model="form.jenis_paket.value"
                  @input="clearError(form.jenis_paket)"
                  :disabled="state"
                  placeholder="Pilih Tipe Sertifikat"
                  expanded>
                    <option value="CT-1">Computational Thinking 1</option>
                    <option value="CT-2">Computational Thinking 2</option>
                    <option value="CT-Advanced">Computational Thinking Advanced</option>
                    <option value="INF">Informatika</option>
                </b-select>
              </b-field>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="columns">
            <div class="column">
              <b-field
                label="Tanda Tangan Koordinator"
                :type="form.ttd_koordinator.type"
                :message="form.ttd_koordinator.message">
                <b-upload
                  v-model="form.ttd_koordinator.value"
                  accept="image/*"
                  @input="readImageTtdKoordinator"
                  drag-drop
                  :disabled="state">
                  <section class="section">
                    <div class="content has-text-centered">
                      <p v-if="uploadTtdKoordinator">
                        <b-icon icon="upload" size="is-medium"> </b-icon>
                      </p>
                      <p v-if="uploadTtdKoordinator">
                        Drop your files here or click to upload
                      </p>

                      <div class="image-preview" v-if="previewTtdKoordinator">
                        <img class="preview" :src="gambarTtdKoordinator" />
                      </div>
                      <div class="image-preview" v-if="previewEditTtdKoodinator">
                        <img class="preview" :src="gambarTtdKoordinator" />
                      </div>
                    </div>
                  </section>
                </b-upload>
              </b-field>
              <div class="tags">
                <span class="tag is-primary" v-if="previewTtdKoordinator">
                  {{ form.ttd_koordinator.value.name }}
                  <button
                    v-if="!state"
                    class="delete is-small"
                    type="button"
                    @click="deleteDropFileTtdKoordinator()">
                  </button>
                </span>

                <span class="tag is-primary" v-if="previewEditTtdKoodinator">
                  {{ form.ttd_koordinator.value }}
                  <button
                    v-if="!state"
                    class="delete is-small"
                    type="button"
                    @click="deleteDropFileTtdKoordinator()"
                  ></button>
                </span>
              </div>
            </div>
            <div class="column">
              <b-field
                label="Unggah Tabel"
                :type="form.photo_tabel.type"
                :message="form.photo_tabel.message">
                <b-upload
                  v-model="form.photo_tabel.value"
                  accept="image/*"
                  @input="readImageTabel"
                  drag-drop
                  :disabled="state">
                  <section class="section">
                    <div class="content has-text-centered">
                      <p v-if="uploadTabel">
                        <b-icon icon="upload" size="is-medium"> </b-icon>
                      </p>
                      <p v-if="uploadTabel">
                        Drop your files here or click to upload
                      </p>

                      <div class="image-preview" v-if="previewTabel">
                        <img class="preview" :src="gambarTabel" />
                      </div>
                      <div class="image-preview" v-if="previewEditTabel">
                        <img class="preview" :src="gambarTabel" />
                      </div>
                    </div>
                  </section>
                </b-upload>
              </b-field>
              <div class="tags">
                <span class="tag is-primary" v-if="previewTabel">
                  {{ form.photo_tabel.value.name }}
                  <button
                    v-if="!state"
                    class="delete is-small"
                    type="button"
                    @click="deleteDropFileTabel()">
                  </button>
                </span>

                <span class="tag is-primary" v-if="previewEditTabel">
                  {{ form.photo_tabel.value }}
                  <button
                    v-if="!state"
                    class="delete is-small"
                    type="button"
                    @click="deleteDropFileTabel()"
                  ></button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- <vue-cropper 
        v-show="gambarTabel" 
        ref="cropper" 
        :src="gambarTabel" 
        :guides="true"
        :view-mode="2"
        :aspect-ratio="3/2">
      </vue-cropper> -->  
      <!-- <b-field  class="file" label="Tanda Tangan-Kiri"
        :type="form.ttd_kiri.type"
        :message="form.ttd_kiri.message">
            <b-upload v-model="form.ttd_kiri.value" expanded>
                <a class="button is-primary is-fullwidth" @click="btnTtdKiriClick">
                    <b-icon icon="upload"></b-icon>
                    <span>Unggah Gambar</span>
                </a>
            </b-upload>
        </b-field> -->

      <!-- <b-field  label="Nama Pengesahan-Kiri"
        :type="form.nama_gelar_kiri.type"
        :message="form.nama_gelar_kiri.message">
            <b-input name="nama_gelar_kiri" @input="clearError(form.nama_gelar_kiri)"  
            placeholder="Nama Pengesahan-Kiri" v-model="form.nama_gelar_kiri.value" expanded :disabled="state"></b-input>
        </b-field>
         <b-field  label="Jabatan-Kanan"
        :type="form.jabatan_kanan.type"
        :message="form.jabatan_kanan.message">
            <b-input name="jabatan_kanan" @input="clearError(form.jabatan_kanan)"  
            placeholder="Jabatan Kanan" v-model="form.jabatan_kanan.value" expanded :disabled="state"></b-input>
        </b-field> -->
      <!-- <b-field  class="file"
         label="Tanda Tangan-Kanan"
        :type="form.ttd_kanan.type"
        :message="form.ttd_kanan.message">
            <b-upload v-model="form.ttd_kanan.value" expanded>
                <a class="button is-primary is-fullwidth" @click="btnTTdKananClick">
                    <b-icon icon="upload"></b-icon>
                    <span>Unggah Gambar</span>
                </a>
            </b-upload>
        </b-field> -->
      <!-- <b-field label="Tanda Tangan-Kanan"
        :type="form.ttd_kanan.type"
        :message="form.ttd_kanan.message">
            <b-upload v-model="form.ttd_kanan.value" accept="image/*" @input="readImageTtdKanan" drag-drop :disabled="state">
            <section class="section">
                <div class="content has-text-centered">
                <p v-if="uploadTtdKanan">
                    <b-icon icon="upload" size="is-medium">
                    </b-icon>
                </p>
                <p v-if="uploadTtdKanan">
                    Drop your files here or click to upload
                </p>
                
                <div class="image-preview" v-if="previewTtdKanan">
                    <img class="preview" :src="gambarTtdKanan">
                </div>
                <div class="image-preview" v-if="previewEditTtdKanan">
                    <img class="preview" :src="gambarTtdKanan">
                </div>
                </div>
            </section>
            </b-upload>
        </b-field> -->
      <!-- <div class="tags">
        <span class="tag is-primary" v-if="previewTtdKanan">
            {{ form.ttd_kanan.value.name }}
            <button
            class="delete is-small"
            type="button"
            @click="deleteDropFileTtdKanan()"
            ></button>
        </span>

        <span class="tag is-primary" v-if="previewEditTtdKanan">
            {{ form.ttd_kanan.value }}
            <button
            class="delete is-small"
            type="button"
            @click="deleteDropFileTtdKanan()"
            ></button>
        </span>
        </div> -->

      <!-- <b-field label="Nama Pengesahan-Kanan"
        :type="form.nama_gelar_kanan.type"
        :message="form.nama_gelar_kanan.message">
            <b-input name="nama_gelar_kanan" @input="clearError(form.nama_gelar_kanan)"  
            placeholder="Nama Pengesahan-Kanan" v-model="form.nama_gelar_kanan.value" expanded :disabled="state"></b-input>
        </b-field> -->
      <p class="mt-16 color-danger">Aktifkan Tombol untuk Tambah Sertifikat</p>
      <div class="rows mt-24">
        <div class="row">
          <div class="columns">
            <div class="column">
              <b-button type="is-info" 
              rounded @click="state = false"
              class="btn-block">Aktifkan Form</b-button>
            </div>
            <div class="column">
              <b-button type="is-danger" 
              rounded @click="state = true"
              class="btn-block">Non Aktif Form</b-button>
            </div>
          </div>
        </div>
      </div>
      <div class="rows mt-24">
        <div class="row">
          <div class="columns">
            <div class="column">
              <b-button class="button is-danger btn-block"
                tag="router-link"
                to="/biro/berandasertifikat">
                Kembali
              </b-button>
            </div>
            <div class="column">
              <b-button
                class="btn-block"
                type="is-success"
                @click="confirm()"
                :disabled="state">
                Simpan
              </b-button>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="columns">
        <div class="column">
          <b-button type="is-info" rounded @click="state = false">Edit Form</b-button>
          <b-button type="is-danger" rounded @click="state = true" style="margin-left: 12px">Reset Form</b-button>
        </div>
        <div class="column"></div>
        <div class="column">
          <b-button
            class="is-pulled-right"
            type="is-success"
            rounded
            @click="confirm()"
            :disabled="state">
            Simpan Sertifikat
          </b-button>
        </div>
      </div> -->
    </div>
    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="false"
    >
    </b-loading>
  </section>
</template>

<script>
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'

export default {
  components: {
    VueCropper
  },

  data() {
    return {
      isLoading: true,
      editID: 0,
      actionTitle: "",
      action: "add",
      dataSertifikat: new FormData(),
      detailId: "",
      activeBiro: Object,
      editDataSertifikat: {},
      snackbarMsg: "",
      //LOGO
      // previewLogo:'',
      // previewEditLogo:'',
      // uploadLogo:true,
      //Ttd kiri
      previewTtdKoordinator: "",
      previewEditTtdKoodinator: "",
      uploadTtdKoordinator: true,
      //Ttd Kanan
      previewTabel:'',
      previewEditTabel:'',
      uploadTabel:true,

      // gambarLogo:'',
      // gambarTtdNbo:'',
      gambarTtdKoordinator: "",
      gambarTabel: null,
      gambarTabelCropped: null,
      sertifikat: null,
      state: true,
      form: {
        id_biro: { value: "", type: "", message: "" },
        jenis_paket: { value: null, type: "", message: ""},
        periode_pelaksanaan: { value: "", type: "", message: "" },
        tempat_terbit: { value: "", type: "", message: "" },
        tanggal_terbit: { value: "", type: "", message: "" },
        nama_koordinator: { value: "", type: "", message: "" },
        ttd_koordinator: { value: "", type: "", message: "" },
        photo_tabel:{value:'',type:'',message:''},
        duration:{value:'',type:'',message:''},
        // isi_baris_satu:{value:'',type:'',message:''},
        // isi_baris_dua:{value:'',type:'',message:''},
        // isi_baris_tiga:{value:'',type:'',message:''},

        // jabatan_kiri:{value:'',type:'',message:''},
        // ttd_kiri:{value:'',type:'',message:''},
        // nama_gelar_kiri:{value:'',type:'',message:''},

        // jabatan_kanan:{value:'',type:'',message:''},
        // ttd_kanan:{value:'',type:'',message:''},
        // nama_gelar_kanan:{value:'',type:'',message:''},
      },
      config: {},
    };
  },
  mounted() {
    if (this.$session.exists()) {
      this.config = {
        headers: {
          Authorization: "Bearer " + this.$session.get("token"),
        },
      };
    }
    this.activeBiro = this.$session.get("biro");
    if (this.activeBiro) {
      this.detailId = this.activeBiro.id_biro;
    }

    if(this.$route.params.id)
    {
        this.editID = this.$route.params.id
        this.actionTitle = 'Ubah'
        this.getData()
    }else{
        this.actionTitle = 'Buat'
    }
    this.isLoading = false;
  },
  watch: {
    // logo_univ:function(o){
    //     var reader = new FileReader();
    //     reader.onload = e => this.$emit("load", e.target.result);
    //     reader.readAsText(o[0]);
    //     alert();
    // },
    // ttd_kiri:function(o){
    //     var reader = new FileReader();
    //     reader.onload = e => this.$emit("load", e.target.result);
    //     reader.readAsText(o[0]);
    //     alert();
    // },
    ttd_koordinator: function (o) {
      var reader = new FileReader();
      reader.onload = (e) => this.$emit("load", e.target.result);
      reader.readAsText(o[0]);
      alert();
    },
  },
  methods: {
    //logo univ
    //   readImageLogo(){
    //   var input = this.form.logo_univ.value

    //   if(input){
    //     var reader = new FileReader()
    //     reader.readAsDataURL(input)
    //     reader.onload = (e) => {
    //       this.gambarLogo= e.target.result
    //     }
    //   }
    //   this.uploadLogo = false
    //   this.previewLogo = true
    // },
    // deleteDropFileLogo() {
    //   this.form.logo_univ.value = ''
    //   this.uploadLogo = true
    //   this.previewLogo = false
    //   this.previewEditLogo = false
    // },
    //ttd kiri
    readImageTtdKoordinator() {
      var input = this.form.ttd_koordinator.value;

      if (input) {
        var reader = new FileReader();
        reader.readAsDataURL(input);
        reader.onload = (e) => {
          this.gambarTtdKoordinator = e.target.result;
        };
      }
      this.uploadTtdKoordinator = false;
      this.previewTtdKoordinator = true;
    },
    deleteDropFileTtdKoordinator() {
      this.form.ttd_koordinator.value = "";
      this.uploadTtdKoordinator = true;
      this.previewTtdKoordinator = false;
      this.previewEditTtdKoodinator = false;
    },
    //ttd kanan
    readImageTabel(){
      // this.gambarTabel = null
      // this.gambarTabelCropped = null

      var input = this.form.photo_tabel.value

      if (input) {
        var reader = new FileReader();
        reader.readAsDataURL(input);
        reader.onload = (e) => {
          this.gambarTabel = e.target.result;
        };
      }
      this.uploadTabel = false
      this.previewTabel = true
    },
    // cropImage(){
    //   this.gambarTabelCropped = this.$refs.cropper.getCroppedCanvas().toDataURL();
    //   this.gambarTabel = null
    // },
    deleteDropFileTabel() {
      this.form.photo_tabel.value = ''
      this.uploadTabel = true
      this.previewTabel = false
      this.previewEditTabel = false
    },
    //   btnLogoClick(){
    //       this.$refs.inputFile.click()
    //   },
    //   previewImage(event)
    //   {
    //       var input = event.target.files[0];
    //       this.form.logo_univ.value = input

    //       if(input)
    //       {
    //           var reader = new FileReader();
    //           reader.readAsDataURL(input)
    //           reader.onload = (e) =>
    //           {
    //               this.gambarLogo.e.target.result;
    //           }
    //           reader.readAsDataURL(input)
    //       }
    //   },
    clearError(form) {
      console.log(form);
      form.type = "";
      form.message = "";
    },
    getData() {
      this.isLoading = true;
      var uri = this.$apiUrl + "sertifikat/" + this.editID;

      this.$http
        .get(uri, this.config)
        .then((response) => {
          this.isLoading = false;
          this.sertifikat = response.data.value;
          if (this.sertifikat !== null) {
            this.action = "edit";
            this.formEdit(this.sertifikat);
          }
        })
        .catch(errors => {
          this.isLoading = false;
          this.errors = errors
          this.tableMessage = "Tidak ada Data";
        });
    },
    convertTgl(date) {
      var formDate = date 
      var year = formDate.getFullYear()       
      var month = formDate.getMonth() + 1      
      var date = formDate.getDate()            

      month = (month < 10) ? '0' + month : month
      date = (date < 10) ? '0' + date : date

      var fixedDate = year + '-' + month + '-' + date

      return fixedDate
    },
    formEdit(dataSertifikat) {
      this.form.id_biro.value = dataSertifikat.id_biro;
      this.form.tempat_terbit.value = dataSertifikat.tempat_terbit;
      this.form.tanggal_terbit.value = new Date(dataSertifikat.tanggal_terbit);
      this.form.periode_pelaksanaan.value = dataSertifikat.periode_pelaksanaan;
      this.form.nama_koordinator.value = dataSertifikat.nama_koordinator;
      this.form.photo_tabel.value = dataSertifikat.photo_tabel;
      this.form.ttd_koordinator.value = dataSertifikat.ttd_koordinator;
      this.form.duration.value = dataSertifikat.duration;
      this.form.jenis_paket.value = dataSertifikat.jenis_paket;
      
      // this.form.logo_univ.value = dataSertifikat.logo_univ;
      // this.form.isi_baris_satu.value = dataSertifikat.isi_baris_satu;
      // this.form.isi_baris_dua.value = dataSertifikat.isi_baris_dua;
      // this.form.isi_baris_tiga.value = dataSertifikat.isi_baris_tiga;
      // this.form.ttd_kiri.value = dataSertifikat.ttd_kiri;
      // this.form.jabatan_kiri.value = dataSertifikat.jabatan_kiri;
      // this.form.nama_gelar_kiri.value = dataSertifikat.nama_gelar_kiri;
      // this.form.ttd_kanan.value = dataSertifikat.ttd_kanan;
      // this.form.jabatan_kanan.value = dataSertifikat.jabatan_kanan;
      // this.form.nama_gelar_kanan.value = dataSertifikat.nama_gelar_kanan;

      this.gambarTtdKoordinator = this.$apiUrl + "sertifikat/picture/" + dataSertifikat.ttd_koordinator;
      this.uploadTtdKoordinator = false;
      this.previewEditTtdKoodinator = true;

      this.gambarTabel = null
      this.gambarTabelCropped = null
      this.gambarTabel = this.$apiUrl + 'sertifikat/picture/' + dataSertifikat.photo_tabel

      this.uploadTabel = false
      this.previewEditTabel= true

      // this.gambarTtdKanan = this.$apiUrl + 'sertifikat/picture/' + dataSertifikat.ttd_kanan
      // this.uploadTtdKanan = false
      // this.previewEditTtdKanan = true

      // this.editID = dataSertifikat.id_sertifikat;
    },
    edit() {
      this.state = false;
    },
    checkData() {
      let count = 0;
      if (this.form.jenis_paket.value === "") {
        this.form.jenis_paket.type = "is-danger";
        this.form.jenis_paket.message =
          "Jenis Paket harus di isi";
        count++;
      }
      if (this.form.periode_pelaksanaan.value === "") {
        this.form.periode_pelaksanaan.type = "is-danger";
        this.form.periode_pelaksanaan.message =
          "Tanggal Pelaksanaan harus di isi";
        count++;
      }
      if (this.form.tempat_terbit.value === "") {
        this.form.tempat_terbit.type = "is-danger";
        this.form.tempat_terbit.message =
          "Tempat Terbit Setifikat harus di isi";
        count++;
      }
      if (this.form.tanggal_terbit.value === "") {
        this.form.tanggal_terbit.type = "is-danger";
        this.form.tanggal_terbit.message =
          "Tanggal Terbit Setifikat harus di isi";
        count++;
      }
      if (this.form.nama_koordinator.value === "") {
        this.form.nama_koordinator.type = "is-danger";
        this.form.nama_koordinator.message =
          "Nama Koordinator Biro harus di isi";
        count++;
      }
      if (this.form.ttd_koordinator.value === "") {
        this.form.ttd_koordinator.type = "is-danger";
        this.form.ttd_koordinator.message =
          "Tanda Tangan Koordinator harus di isi";
        count++;
      }
      if (this.form.duration.value === "") {
        this.form.duration.type = "is-danger";
        this.form.duration.message =
          "Durasi Jam harus di isi";
        count++;
      }
      if (this.form.photo_tabel.value === "") {
        this.form.photo_tabel.type = "is-danger";
        this.form.photo_tabel.message =
          "Photo Tabel harus di isi";
        count++;
      }
      // if(this.form.jabatan_kiri.value === "")
      // {
      //     this.form.jabatan_kiri.type = 'is-danger'
      //     this.form.jabatan_kiri.message = "Jabatan Kiri harus harus di isi"
      //     count ++
      // }
      // if(this.form.jabatan_kanan.value === "")
      // {
      //     this.form.jabatan_kanan.type = 'is-danger'
      //     this.form.jabatan_kanan.message = "Jabatan Kanan harus harus di isi"
      //     count ++
      // }
      // if(this.form.nama_gelar_kiri.value === "")
      // {
      //     this.form.nama_gelar_kiri.type = 'is-danger'
      //     this.form.nama_gelar_kiri.message = "Nama Gelar Kiri harus harus di isi 1 Gambar"
      //     count ++
      // }
      // if(this.form.nama_gelar_kanan.value === "")
      // {
      //     this.form.nama_gelar_kanan.type = 'is-danger'
      //     this.form.nama_gelar_kanan.message = "Nama Gelar Kanan harus harus di isi"
      //     count ++
      // }
      //  if(this.form.isi_baris_satu.value === "")
      // {
      //     this.form.isi_baris_satu.type = 'is-danger'
      //     this.form.isi_baris_satu.message = "Baris 1 Sertifikat harus harus di isi"
      //     count ++
      // }
      if (count > 0) return false;
    },
    tambahData() {
      if (this.checkData() == false) {
        this.snackbar("Gagal..Silahkan input lagi", "is-danger");
      } else {
        this.dataSertifikat.append("id_biro", this.detailId);
        this.dataSertifikat.append(
          "jenis_paket",
          this.form.jenis_paket.value
        );
        this.dataSertifikat.append(
          "periode_pelaksanaan",
          this.form.periode_pelaksanaan.value
        );
        this.dataSertifikat.append(
          "tempat_terbit",
          this.form.tempat_terbit.value
        );
        if(this.form.tanggal_terbit.value !== ""){
          this.dataSertifikat.append(
            "tanggal_terbit",
            this.convertTgl(this.form.tanggal_terbit.value)
          );
        }
        this.dataSertifikat.append(
          "nama_koordinator",
          this.form.nama_koordinator.value
        );
        this.dataSertifikat.append(
          "ttd_koordinator",
          this.form.ttd_koordinator.value
        );
        this.dataSertifikat.append(
          "photo_tabel",
          this.form.photo_tabel.value
        );
        this.dataSertifikat.append(
          "duration",
          this.form.duration.value
        );
        // this.dataSertifikat.append("isi_baris_satu",this.form.isi_baris_satu.value)
        // this.dataSertifikat.append("isi_baris_dua",this.form.isi_baris_dua.value)
        // this.dataSertifikat.append("isi_baris_tiga",this.form.isi_baris_tiga.value)
        // this.dataSertifikat.append("jabatan_kiri",this.form.jabatan_kiri.value)
        // this.dataSertifikat.append("ttd_kiri",this.form.ttd_kiri.value)
        // this.dataSertifikat.append("nama_gelar_kiri",this.form.nama_gelar_kiri.value)
        // this.dataSertifikat.append("jabatan_kanan",this.form.jabatan_kanan.value)
        // this.dataSertifikat.append("ttd_kanan",this.form.ttd_kanan.value)
        // this.dataSertifikat.append("nama_gelar_kanan",this.form.nama_gelar_kanan.value)

        this.isLoading = true;
        var uri = this.$apiUrl + "sertifikat";

        this.$http
          .post(uri, this.dataSertifikat, this.config)
          .then((response) => {
            this.isLoading = false
            this.snackbarMsg = response.message;
            this.$router.push( { name: 'BerandaSertifikat' } )
            this.snackbar("Data berhasil ditambahkan", "is-success");
          })
          .catch((error) => {
            this.isLoading = false
            this.errors = error;
            if (this.errors.message == "Request failed with status code 400") {
              this.snackbar(
                "Gagal tambah data.Silahkan Input Lagi",
                "is-danger"
              );
            } else {
              this.snackbar(
                "Terjadi kesalahan. Silahkan coba lagi",
                "is-danger"
              );
            }
          });
      }
    },
    editData() {
      if (this.checkData() == false) {
        this.snackbar(
          "Gagal tambah data. Sepertinya inputan salah...",
          "is-danger"
        );
      } else {
        this.dataSertifikat.append("id_biro", this.detailId);
        this.dataSertifikat.append(
          "jenis_paket",
          this.form.jenis_paket.value
        );
        this.dataSertifikat.append(
          "periode_pelaksanaan",
          this.form.periode_pelaksanaan.value
        );
        this.dataSertifikat.append(
          "tempat_terbit",
          this.form.tempat_terbit.value
        );
        if(this.form.tanggal_terbit.value !== ""){
          this.dataSertifikat.append(
            "tanggal_terbit",
            this.convertTgl(this.form.tanggal_terbit.value)
          );
        }
        this.dataSertifikat.append(
          "nama_koordinator",
          this.form.nama_koordinator.value
        );
        this.dataSertifikat.append(
          "ttd_koordinator",
          this.form.ttd_koordinator.value
        );
        this.dataSertifikat.append(
          "photo_tabel",
          this.form.photo_tabel.value
        );
        this.dataSertifikat.append(
          "duration",
          this.form.duration.value
        );
        // this.dataSertifikat.append("logo_univ",this.form.logo_univ.value)
        // this.dataSertifikat.append("isi_baris_satu",this.form.isi_baris_satu.value)
        // this.dataSertifikat.append("isi_baris_dua",this.form.isi_baris_dua.value)
        // this.dataSertifikat.append("isi_baris_tiga",this.form.isi_baris_tiga.value)
        // this.dataSertifikat.append("jabatan_kiri",this.form.jabatan_kiri.value)
        // // this.dataSertifikat.append("ttd_kiri",this.ttd_kiri.value)
        // this.dataSertifikat.append("nama_gelar_kiri",this.form.nama_gelar_kiri.value)
        // this.dataSertifikat.append("jabatan_kanan",this.form.jabatan_kanan.value)
        // // this.dataSertifikat.append("ttd_kanan",this.ttd_kanan.value)
        // this.dataSertifikat.append("nama_gelar_kanan",this.form.nama_gelar_kanan.value)

        // if(typeof(this.form.logo_univ.value) != 'string') {
        //   this.dataSertifikat.append("logo_univ", this.form.logo_univ.value)
        // }
        // if(typeof(this.form.ttd_kiri.value) != 'string') {
        //   this.dataSertifikat.append("ttd_kiri", this.form.ttd_kiri.value)
        // }
        if (typeof this.form.ttd_koordinator.value != "string") {
          this.dataSertifikat.append(
            "ttd_koordinator",
            this.form.ttd_koordinator.value
          );
        }

        console.log(this.form);

        this.isLoading = true;
        var uri = this.$apiUrl + "sertifikat/" + this.editID;

        this.$http
          .post(uri, this.dataSertifikat, this.config)
          .then((response) => {
            this.isLoading = false;
            this.$router.push( { name: 'BerandaSertifikat' } )
            // this.snackbarMsg = response.message
            this.snackbar("Data berhasil diedit", "is-success");
            this.state = true;
          })
          .catch((error) => {
            this.isLoading = false;
            this.errors = error;
            if (this.errors.message == "Request failed with status code 400") {
              this.snackbar(
                "Edit gagal. Sepertinya inputan salah...",
                "is-danger"
              );
            } else {
              this.snackbar(
                "Terjadi kesalahan. Silahkan coba lagi",
                "is-danger"
              );
            }
          });
      }
    },
    confirm() {
      this.editID == 0 ? this.tambahData() : this.editData();
    },
    snackbar(snackbarMessage, type) {
      this.$buefy.toast.open({
        duration: 5000,
        message: snackbarMessage,
        type: type,
        position: "is-top",
        actionText: "OK",
        queue: false,
      });
    },
  },
};
</script>
<style scoped>
img.preview {
  width: 200px;
  background-color: white;
  border: 1px solid #ddd;
  padding: 5px;
}
.mw-980 {
  max-width: 980px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}
</style>

